import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-card">
        <h1>404</h1>
        <h2>Stránka nenalezena</h2>
        <p>Odkaz, který jste zadali, neexistuje nebo byl přesunut.</p>
        <Link to="/" className="back-home-button">
          Zpět na hlavní stránku
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
